import React from 'react'
import { Button } from 'antd'

import './StageHeader.scss'

const StageHeader = ({ onSkipToShotList, isSkipDisabled }) => {
  return (
    <div className="creative-direction-chat__stage-header">
      <div>
        <h2>Chat</h2>
        <p>Continue the conversation and review each completed step below.</p>
      </div>
      {onSkipToShotList ? (
        <div className="creative-direction-chat__skip-card">
          <div>
            <strong>Want to skip AI Director?</strong>
            <span>
              You can go straight to Shot List. AI will still generate shots
              from your story; use this chat only if you want extra creative
              guidance.
            </span>
          </div>
          <Button
            icon="arrow-right"
            disabled={isSkipDisabled}
            onClick={onSkipToShotList}
          >
            Skip to Shot List
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default StageHeader
